import gql from 'graphql-tag';

export default gql`
  query publicCoupon($eventId: String!, $code: String!) {
    publicCoupon(eventId: $eventId, code: $code) {
      code
      discountPercentage
      discountValue
      maxTicketsByCoupon
      type
      ticketTypeIds
      dateRange {
        start
        end
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/site-render/src/graphql/queries/publicCoupon.js